import React, { useMemo, useState } from "react";
import { ListProductUseCase } from "../../../Usecase/Products/list-product-usecase";
import { useToast } from "../../../Hooks/ToasContext";
import { IExportProductPayload, IProductEntity, IProductsListPayload } from "../../../Services/api/products/products.interface";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Box, Button, Typography } from '@mui/material'
import { FormatMoney } from "../../../utils/formatMoney";
import { useForm } from "react-hook-form";
import { DestroyProductUseCase } from "../../../Usecase/Products/destroy-product-usecase";
import { TCategoryStore } from "../../../Services/api/categories/categories.interface";
import { ExportExcelProductUseCase } from "../../../Usecase/Products/export-excel-product-usecase";
import { downloadBlob } from "../../../utils/downloadBlob";
import { TStoreType } from "../../../Services/api/service-orders/service-order.interface";
import { IOrdersListPayload } from "../../../Services/api/orders/orders.interface";


interface IUseListProductsProps {
    listProductUseCase: ListProductUseCase
    destroyProductUseCase: DestroyProductUseCase
    exportExcelProductUseCase: ExportExcelProductUseCase
}
export function useListProducts({ listProductUseCase, destroyProductUseCase, exportExcelProductUseCase }: IUseListProductsProps){
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [data, setData] = useState<IProductEntity[]>([])
    const [totalRegisters, setTotalRegisters] = useState(0)
    const [showFiltersModal, setShowFiltersModal] = useState(false)
    const [itemToDestroy, setItemToDestroy] = useState<IProductEntity>()
    const [currentFilters, setCurrentFilters] = useState<IProductsListPayload>({ page: 1, store: undefined })

    const { control } = useForm()

    const { showToast } =  useToast()

    const listProdcuts = async ({ page: currentPage, searchBy, store}: { page : number; searchBy?: string; store?: TCategoryStore }) => {
   
        try {
          setLoading(true)

          // Merge current filters with new search/filter parameters
          const filters = {
            ...currentFilters,
            page: currentPage || currentFilters.page,
            searchBy: searchBy !== undefined ? searchBy : currentFilters.searchBy,
            store
          }

          // Update current filters
          setCurrentFilters(filters)
          
          const listResult = await listProductUseCase.handle(filters);

          if (listResult.isFailure) {
       
            showToast(String(listResult?.error?.error), 'error');
            return;
          }

         const list = listResult.getValue()
      
         if(list){
            setData(list.data)
            setTotalRegisters(list.total)
         }

         

         setPage(currentPage)
        } catch (error) {
          console.log("error listProducts function: ", error)
        } finally {
          setLoading(false);
        }
      };

      const handlePageChangeProducts = (data: IProductsListPayload) => {
        // Tenta múltiplas estratégias de scroll para garantir que funcione
        try {
          // Estratégia 1: Scroll do window
          window.scrollTo({ top: 0, behavior: 'smooth' })
          
          // Estratégia 2: Scroll do document.documentElement (para navegadores que não suportam window.scrollTo)
          document.documentElement.scrollTop = 0
          
          // Estratégia 3: Scroll do body
          document.body.scrollTop = 0
        } catch (error) {
          console.log('Erro ao fazer scroll:', error)
        }
        
        listProdcuts({ ...currentFilters, ...data })
    }

      const handleExportExcel = async () => {
   
        try {
          setLoading(true)

          // Merge current filters with new search/filter parameters
          const filters : IExportProductPayload = {
            searchBy: currentFilters.searchBy,
            store: currentFilters.store as TStoreType,
            brand: currentFilters.brand
          }

      
          const blobResult = await exportExcelProductUseCase.handle(filters);

          if (blobResult.isFailure) {
       
            showToast(String(blobResult?.error?.error || 'Erro ao exportar Excel'), 'error');
            return;
          }

          const blob = blobResult.getValue()
          
         if(blob){
            downloadBlob(blob, 'products.xlsx')
         }

        } catch (error) {
          console.log("error listProducts function: ", error)
        } finally {
          setLoading(false);
        }
      };

    

    const list = useMemo(() => {
        const rows = data?.map(product => {

            return {
                id: product.id,
                name: product.name,
                code: product.code,
                internalName: product?.internalName || "Não informado",
                price: FormatMoney(Number(product?.price)) || 'R$ 0.00',
                photo: product?.images[0]?.link || 'https://acdn.mitiendanube.com/stores/002/907/105/themes/common/logo-1336738559-1706047471-a90c2b04f7208c4f190adf866d8df0b51706047472-320-0.webp',
                b2bNuvemShopPrice: FormatMoney(Number(product?.b2bNuvemShopPrice)) || 'R$ 0.00',
                b2cNuvemShopPrice: FormatMoney(Number(product?.b2cNuvemShopPrice)) || 'R$ 0.00',
            }
        })

        return rows
    }, [data])

    const handleDestroyProduct = async () => {
          console.log("itemToDestroy", itemToDestroy)
      try {
        setLoading(true)
        
        const listResult = await destroyProductUseCase.handle(itemToDestroy?.id || '');

        if (listResult.isFailure) {
     
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

        setItemToDestroy(undefined)
        showToast('Removido com sucesso.', 'success');
        await listProdcuts({ page })

      

      
      } catch (error) {
        console.log("error listProducts function: ", error)
      } finally {
        setLoading(false);
      }
    }

    const handleFilterSelect = (payload: IProductsListPayload) => {
      listProdcuts({ ...currentFilters, ...payload, page: 1 })
    }

      

    return {
        loading,
        listProdcuts,
        list,
        data,
        totalRegisters,
        control,
        showFiltersModal,
        setShowFiltersModal,
        setItemToDestroy,
        itemToDestroy,
        handleDestroyProduct,
        handleFilterSelect,
        currentFilters,
        handleExportExcel,
        handlePageChangeProducts
        
    }
}